import { yupResolver } from '@hookform/resolvers/yup';
import Box from '@mui/material/Box';
import { t } from 'i18next';
import { forwardRef } from 'react';
import { useForm } from 'react-hook-form';

import TextInput from '~components/FormFields/v2/TextInput';
import useFormSubmitHandle, { FormSubmitHandle } from '~formsShared/useFormSubmitHandle';

import { HaulWareSetupDto, haulWareSetupSchema } from './haulWareConnectionSchema';

export type HaulWareSetupFormHandler = FormSubmitHandle<HaulWareSetupDto>;

interface HaulWareSetupFormProps {
  isDisabled: boolean;
}

const HaulWareSetupForm = forwardRef<HaulWareSetupFormHandler, HaulWareSetupFormProps>(
  function HaulWareSetupForm({ isDisabled }, ref) {
    const form = useForm<HaulWareSetupDto>({
      resolver: yupResolver(haulWareSetupSchema),
      mode: 'onSubmit',
      reValidateMode: 'onChange',
      defaultValues: { apiUser: '', apiPassword: '', appCode: '' },
    });
    const { control } = form;

    useFormSubmitHandle(ref, form);

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, maxWidth: '560px' }}>
        <TextInput
          control={control}
          dataUi="haul-ware-api-user"
          isDisabled={isDisabled}
          isRequired
          label={t('administration.integration.haul_ware.form.api_user_label')}
          name="apiUser"
        />

        <TextInput
          control={control}
          dataUi="haul-ware-api-password"
          slotProps={{ htmlInput: { type: 'password' } }}
          isDisabled={isDisabled}
          isRequired
          label={t('administration.integration.haul_ware.form.api_password_label')}
          name="apiPassword"
        />

        <TextInput
          control={control}
          dataUi="haul-ware-app-code"
          isDisabled={isDisabled}
          isRequired
          label={t('administration.integration.haul_ware.form.app_code_label')}
          name="appCode"
        />
      </Box>
    );
  },
);

export default HaulWareSetupForm;
